import React from 'react'
import { Box, Button, Divider, Group, Stack, Text, Title } from '@mantine/core'
import {
    ShieldCheck,
} from 'lucide-react'

import { WithViewModelProps } from '@/shared/types/components'
import formatAmount from '@/utils/format-amount'

import Footer from '../../Footer'
import ListLineItems from '../../shared/ListLineItems/ListLineItems'
import ModalHeader from '../../shared/ModalHeader/ModalHeader'
import PromoCodeInput from '../Payment/PromoCodeInput/PromoCodeInput'

import { useViewModel } from './Details.vm'

export const DetailsTitle = () => {
    const metadata = {
        title: 'Détails de la commande',
        description:
            'Veuillez vérifier les informations ci-dessous avant de passer au paiement.',
    }
    return <ModalHeader {...metadata} />
}

export const Details = () => {
    const viewModel = useViewModel()
    return <DetailsView viewModel={viewModel} />
}

const DetailsView = ({
    viewModel,
}: WithViewModelProps<typeof useViewModel>) => {
    return (
        <>
            <Stack>
                <Box>
                    {!!Object.keys(viewModel.items).length && (
                        <ListLineItems
                            items={viewModel.items!}
                            showShippingTaxes
                            shippingMethods={viewModel.shippingMethods}
                            readonly
                        />
                    )}
                </Box>
                <Box className="px-4 pb-2">
                    <PromoCodeInput />
                </Box>
            </Stack>
            <Footer>
                <Group w="100%">
                    <Stack
                        className="items-start text-left"
                        spacing={0}
                        pb="xs"
                    >
                        <Text c="gray.6">Total</Text>
                        <Group className="gap-0">
                            <Title order={3} color="gray.8">
                                {formatAmount(viewModel.total)}{' '}
                                <small className="text-xs text-gray-400">
                                    (TTC)
                                </small>
                            </Title>
                        </Group>
                    </Stack>
                    <Button
                        onClick={viewModel.onNext}
                        ml="auto"
                        leftIcon={<ShieldCheck className="w-4 h-4" />}
                    >
                        Passer au paiement
                    </Button>
                </Group>
            </Footer>
        </>
    )
}
